import { ID } from './id';
import { LinkedItemType } from './linked-item-type';
import { Roles } from './roles';
import { Timestamp } from './timestamp';

export enum ExternalConnectionsTypes {
  Calendar = 'calendar',
}

export enum ExternalConnectionsProviders {
  Google = 'google',
  Outlook = 'outlook',
}

export enum SyncMode {
  Manual = 'manual',
  Automatic = 'automatic',
}

export enum CalendarDetailsVisibility {
  Visible = 'visible',
  Hidden = 'hidden',
}

export type ExternalConnectionGoogleProviderInfo = {
  email: string;
  id: ID;
};

export type CalendarSetting = {
  linkedItemType: LinkedItemType;
  calendarId: ID;
  mode: SyncMode;
  detailsVisibility?: CalendarDetailsVisibility;
};

export type TaskCalendarOverride = {
  synced?: boolean;
  detailsVisibility?: CalendarDetailsVisibility;
};

export type ExternalConnectionGoogleSettings = {
  calendarBlacklist?: ID[] | null;
  syncedGoals?: ID[] | null;
  syncedLifeAreas?: ID[] | null;
  calendarSettings?: Record<ID, CalendarSetting> | null;
  taskOverrides?: Record<ID, TaskCalendarOverride> | null;
};

export type ExternalConnection = {
  createdAt: Timestamp;
  lastUsedAt: Timestamp;
  id: ID;
  provider: ExternalConnectionsProviders;
  providerInfo: ExternalConnectionGoogleProviderInfo;
  roles: Roles;
  type: ExternalConnectionsTypes;
  updatedAt: Timestamp;
  settings?: ExternalConnectionGoogleSettings | null;
};
